export function fmtDate(value: string | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** "0:a1b2c3…" style shortening for tx hashes and UUIDs. */
export function shortHash(value: string | null | undefined): string {
  if (!value) return '—';
  return value.length <= 14 ? value : `${value.slice(0, 8)}…${value.slice(-6)}`;
}

const OK = new Set(['active', 'paid', 'resolved', 'actioned', 'confirmed']);
const WARN = new Set(['suspended', 'pending', 'open', 'awaiting', 'flagged']);
const DANGER = new Set(['banned', 'failed', 'expired', 'rejected', 'cancelled', 'refunded']);

export function badgeClass(status: string | null | undefined): string {
  const s = (status ?? '').toLowerCase();
  if (OK.has(s)) return 'badge badge-ok';
  if (WARN.has(s)) return 'badge badge-warn';
  if (DANGER.has(s)) return 'badge badge-danger';
  return 'badge';
}
